import CurrentEnv from "./envs/CurrentEnv";

const logger = CurrentEnv.logger();

export default logger;